<div class="card mb-4" id="folios-container" *ngIf="planActual">
	<div class="card-header d-flex align-items-center justify-content-between mb-0">
		<div class="d-flex align-items-center mb-0">
			<div class="symbol symbol-40 symbol-dark-primary mr-5">
				<span class="symbol-label">
					<span [inlineSVG]="'./assets/media/svg/icons/Files/Selected-file.svg'" cacheSVG="true" class="svg-icon svg-icon-xl svg-icon-primary"></span>
				</span>
			</div>
			<div class="d-flex flex-column font-weight-bold">
				<h4 class="text-dark text-hover-primary mb-1 font-size-xl">Resumen de mi Plan</h4>
				<span class="text-muted">Resumen de tu plan</span>
			</div>
		</div>
		<button *ngIf="planActual && (planActual.pagado == false || enMora)" (click)="abrirPDF()" class="btn btn-sm btn-success mr-2">¿Como pagar?</button>
	</div>
	<div class="card-content">
		<div class="card-body">
			<div class="d-flex">
				<!--begin: Info-->
				<div class="flex-grow-1">
					<!--begin: Title-->
					<div class="d-flex align-items-center justify-content-between flex-wrap">
						<div class="mr-3">
							<!--begin::Name-->
							<a href="#" class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">{{ planActual.nombreEmpresa }}</a>
							<!--end::Name-->
							<!--begin::Contacts-->
							<div class="d-flex flex-wrap my-2">
								<a href="#" class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
									<i class="fa-regular fa-id-badge"></i>
									Rut: {{ planActual.rutEmpresa }}</a
								>
								<a href="#" class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
									<i class="fa-regular fa-file-contract"></i>
									Plan: {{ planActual.nombrePlan }}</a
								>
								<a href="#" class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"> <i class="fa-regular fa-at mr-1"></i>{{ planActual.correoEmpresa }}</a>
							</div>
							<!--end::Contacts-->
						</div>
					</div>
					<!--end: Title-->
					<!--begin: Content-->
					<div class="row">
						<div class="col-12">
							<div class="d-flex flex-wrap align-items-center py-2">
								<div class="d-flex align-items-center mr-10" style="flex-grow: 2">
									<div class="mr-6">
										<div class="font-weight-bold mb-2">Válido Desde</div>
										<span class="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">{{ planActual.fechaContratacion | date : "dd/MM/y" }}</span>
									</div>
									<div class="">
										<div class="font-weight-bold mb-2">Válido Hasta</div>
										<span class="btn btn-sm btn-text btn-light-danger text-uppercase font-weight-bold">{{ planActual.fechaCaducidad | date : "dd/MM/y" }}</span>
									</div>
								</div>
								<div class="flex-grow-1 flex-shrink-1 w-150px w-xl-300px mt-4 mt-sm-0">
									<span class="font-weight-bold">Uso DTE del mes actual:</span>
									<span class="font-weight-bolder text-dark ml-3">{{ planActual.currentDte | number : "1." }} / {{ planActual.maxDte | number : "1." }} ({{ (100 * planActual.currentDte) / planActual.maxDte }}%)</span>
									<div class="progress progress-xs mt-2 mb-2" *ngIf="planActual.maxDte != -1">
										<div class="progress-bar bg-success" role="progressbar" [style.width.%]="(100 * planActual.currentDte) / planActual.maxDte" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--end: Content-->
				</div>
				<!--end: Info-->
			</div>
			<ng-container *ngIf="loading">
				<div class="row">
					<div class="offset-5 col-1">
						<span class="spinner spinner-primary spinner-lg ml-5"></span>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
